module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-cart-79c146838133f115500d1a54db0a4fb1.gif";